/*
 * File: index.tsx
 * Desc: 表单多输入框组件
 * File Created: 2019-10-15 09:49:12
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React from 'react';
import { Form, Input, Button } from 'antd';
import { FormBaseProps } from '../form-input';
import { FormProps } from 'antd/lib/form';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { uuid } from '../utils';

interface IFieldKey {
    key: string;
    width: string;
    label: string;
    placeholder: string;
}

interface FormInputMultipleProps extends FormBaseProps, Omit<FormProps, 'onChange'> {
    onChange?: () => void;
    fieldKeys: IFieldKey[];
}

const FormInputMultiple = (props: FormInputMultipleProps) => {
    const {
        label,
        labelCol,
        wrapperCol,
        field,
        initialValue,
        required,
        validator,
        fieldKeys,
    } = props;
    const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form as WrappedFormUtils;

    /** 表单的值 */
    const values = getFieldValue(field) || [];

    /**
     * 添加对应坐标的值
     * @param value
     * @param index
     */
    function setFormValue(value: any, index: number) {
        const newValue = Object.assign([], values, {
            [index]: { ...values[index], ...value },
        }).filter((v: any) => !!v);
        setFieldsValue({ [field]: newValue });
    }

    function deleteValue(index: number) {
        setFieldsValue({ [field]: values.filter((_value: any, i: number) => i !== index) });
    }
    return (
        <Form.Item
            {...{
                label,
                labelCol,
                wrapperCol,
            }}
            className={props.className}
        >
            {getFieldDecorator(field, {
                initialValue,
                rules: [
                    { required, message: `请输入${label}` },
                    {
                        validator: (rule, value, callback) =>
                            validator ? validator(rule, value, callback) : callback(),
                    },
                ],
            })(<Input style={{ display: 'none' }} />)}
            {props.readOnly ? (
                props.render ? (
                    props.render(values)
                ) : (
                    <span>{values}</span>
                )
            ) : (
                values.map((value: any, index: number) => (
                    <Input.Group compact>
                        {fieldKeys.map((fieldKey, i: number) => (
                            <Input
                                title={`请输入${fieldKey.label}`}
                                placeholder={`请输入${fieldKey.label}`}
                                key={value.key + i}
                                style={{
                                    width:
                                        fieldKey.width || `${(80 / fieldKeys.length).toFixed(2)}%`,
                                }}
                                value={value[fieldKey.key]}
                                onChange={e =>
                                    setFormValue({ [fieldKey.key]: e.target.value }, index)
                                }
                            />
                        ))}
                        <Button
                            type="danger"
                            style={{ width: '20%' }}
                            onClick={() => deleteValue(index)}
                        >
                            删除
                        </Button>
                    </Input.Group>
                ))
            )}
            {!props.readOnly && (
                <Button
                    type="primary"
                    onClick={() => setFormValue({ key: uuid() }, values.length + 1)}
                >
                    添加
                </Button>
            )}
        </Form.Item>
    );
};

export default FormInputMultiple;
